import type { SxProps, Theme } from "@mui/material/styles";
import theme from "../../theme";

export const sx: Record<string, SxProps<Theme>> = {
    rootSx: { display: "grid", gap: 2, gridTemplateRows: "auto auto 1fr", textAlign: "center" },

    toolIcon: (theme: Theme) => ({
        // Responsive square size: never smaller than 40px, never bigger than 72px
        width: "clamp(80px, 12vw, 144px)",
        height: "clamp(80px, 12vw, 144px)",

        // Keep 1:1 box, don’t squish the icon
        aspectRatio: "1 / 1",
        objectFit: "contain",

        marginTop: "auto",
        marginBottom: "auto",

        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),

        [theme.breakpoints.down("sm")]: {
            marginLeft: "auto",
            marginRight: "auto",
        }
    }),


    titleCardSx: {
        justifyContent: "center",
        width: "max-content",
        display: "flex",
    },

    titleSx: {
        display: "inline",
        marginTop: "auto",
        marginRight: theme.spacing(3),
        marginBottom: "auto",
        fontWeight: "bold"
    },

    topRow: {
        display: "grid",
        gap: 2,
        gridTemplateColumns: "1fr 1fr",
        [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
    },

    cardSx: {
        "& .MuiCardHeader-title": {
            color: theme.palette.primary.main,
        },
    },

    cardTitle: { fontWeight: 700, letterSpacing: 0.4, color: "text.secondary" },

    entityRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .MuiFormControlLabel-root": { m: 0 },
    },

    scheduleRow: { display: "flex", alignItems: "center", justifyContent: "space-between", py: 0.5 },

    loading: { display: "flex", alignItems: "center", gap: 1, color: "text.secondary" },

    titleRow: { display: "flex", alignItems: "center", justifyContent: "space-between", px: 1 },

    windowPill: {
        px: 2, py: 0.75, borderRadius: 2,
        bgcolor: theme.palette.grey[100],
        border: `1px solid ${theme.palette.divider}`,
    },

    chartCard: {
        bgcolor: "background.paper",
        borderRadius: 2,
        p: 2.5,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: `0 1px 2px ${theme.palette.action.disabledBackground}`,
    },

    chartSvg: {
        width: "100%",
        height: 280,
        display: "block",
        color: theme.palette.primary.main, // area fill color
        "& text": { fill: theme.palette.text.secondary },
    },

    formRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, my: 1 },

    dateTimeSx: {
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.dark,
        },
    },

    buttonSx: {
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        borderRadius: .5,
        border: `1px solid ${theme.palette.primary.dark}`,
        color: theme.palette.primary.contrastText,
        textColor: theme.palette.primary.contrastText,
        backgroundImage: `linear-gradient(
          0deg,
          ${theme.palette.secondary.main},
          ${theme.palette.primary.dark}
        )`,



    }
};
